import React from 'react'
import Navbar from '../Navbar'
import { Helmet } from 'react-helmet-async'
import './Policies.css'

export const PrivacyPolicy = () => {

    function handleClick() {
        document.getElementById('anchorHome').click()
    }
    return (
        <>
            <Helmet>
                <link rel="canonical" href="https://robustik.com/privacy-policy" />
            </Helmet>
            <section className='hero policies '>
                <div className="container">
                    <div className=' hh2 ' data-aos="fade-up" data-aos-delay="200">
                        <span className="">Privacy Policy</span>
                    </div>
                    {/* <p style={{ "marginTop": "10px" }} data-aos="fade-up" data-aos-delay="300">Your message just showed up in our inbox. Talk to you soon!</p> */}
                    {/* <div className="font-extralight" data-aos="fade-up" data-aos-delay="400"></div> */}

                    {/* <div className="mt-10"></div> */}


                </div>
            </section>
            <section className="policies" data-aos="fade-up" data-aos-delay="300">
                <div className="container">
                    <div className="topic">
                        <div className="heading">1. Introduction</div>
                        <div className="content" >
                            <p>Welcome to <strong>Robustik</strong> ("Robustik," "we," "our," or "us").</p>
                            <p>At Robustik, we recognize that privacy is an important part of building trust with our clients, business partners, and Website visitors. We are committed to protecting your Personal Information through responsible, transparent, and secure data handling practices that align with applicable privacy laws and recognized industry standards.</p>
                            <p>This Privacy Policy explains how we collect, use, process, store, disclose, transfer, retain, and safeguard your Personal Information whenever you:
                            </p>
                            <ul>
                                <li>Visit our Website.</li>
                                <li>Use our Services.</li>
                                <li>Contact us through any communication channel.</li>
                                <li>Request a quotation or consultation.</li>
                                <li>Purchase or use our Services.</li>
                                <li>Submit project information or documentation.</li>
                                <li>Interact with our marketing materials.</li>
                                <li>Otherwise engage with Robustik.</li>
                            </ul>
                            <p>Our objective is to provide clear and transparent information regarding our privacy practices while ensuring compliance with applicable laws, contractual obligations, and commercially reasonable security standards.</p>
                            <p>By accessing or using our Website or Services, you acknowledge that you have read, understood, and agreed to the practices described in this Privacy Policy.</p>
                            <p>If you do not agree with this Privacy Policy, you should discontinue using our Website and Services.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">2. Scope</div>
                        <div className="content">
                            <p>
                                This Privacy Policy applies to all Personal Information collected by Robustik through its digital platforms, business communications, and professional services.
                            </p>

                            <p>This includes, but is not limited to:</p>
                            <ul>
                                <li>Official Website.</li>
                                <li>Landing Pages.</li>
                                <li>Contact Forms.</li>
                                <li>Consultation Request Forms.</li>
                                <li>Proposal Request Forms.</li>
                                <li>Client Onboarding Forms.</li>
                                <li>Customer Support Requests.</li>
                                <li>Email Communications.</li>
                                <li>WhatsApp Communications.</li>
                                <li>Marketing Campaigns.</li>
                                <li>Future Client Portal.</li>
                                <li>Future SaaS Products.</li>
                                <li>Future Web Applications.</li>
                                <li>Future Mobile Applications.</li>
                                <li>APIs and Integrations operated by Robustik.</li>
                                <li>Any online products or services operated under the Robustik brand.</li>
                            </ul>
                            <p>
                                This Privacy Policy applies regardless of whether you access our Services from a desktop computer, laptop, tablet, mobile device, or any other supported platform.
                            </p>
                            <p>
                                This Privacy Policy does <strong className="text-primary">not</strong> apply to third-party websites, applications, platforms, or services that are not owned or controlled by Robustik, even if they are linked from our Website. We encourage you to review the privacy policies of those third parties before providing any Personal Information.
                            </p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">3. Definitions</div>
                        <div className="content" >
                            <p>
                                For the purposes of this Privacy Policy, the following terms shall have the meanings set forth below:
                            </p>

                            <div className="sub-heading">Company</div>
                            <p>
                                "Company" means <strong className="text-primary">Robustik LLC</strong>, or <strong className="text-primary">Robustik</strong> during its pre-registration business operations.
                            </p>
                            <div className="sub-heading">Website</div>
                            <p>
                                "Website" means every webpage, landing page, subdomain, application, client portal, API endpoint, digital platform, or other online property owned, operated, or controlled by Robustik.
                            </p>

                            <div className="sub-heading">Services</div>
                            <p>
                                "Services" include, but are not limited to:
                            </p>
                            <ul>
                                <li>Website Design.</li>
                                <li>Website Development.</li>
                                <li>UI/UX Design.</li>
                                <li>Logo Design.</li>
                                <li>Branding.</li>
                                <li>Graphics Design.</li>
                                <li>Search Engine Optimization (SEO).</li>
                                <li>Social Media Marketing.</li>
                                <li>Software Development.</li>
                                <li>SAAS Development.</li>
                                <li>API Development & Integration.</li>
                                <li>E-Commerce Solutions.</li>
                                <li>Website Maintenance.</li>
                                <li>Hosting Services.</li>
                                <li>Technical Consulting.</li>
                                <li>Digital Strategy.</li>
                                <li>Artificial Intelligence (AI) Solutions.</li>
                                <li>Workflow Automation.</li>
                                <li>Cloud-Based Solutions.</li>
                                <li>Any current or future products or professional services offered by Robustik.</li>
                            </ul>


                            <div className="sub-heading">Personal Information</div>
                            <p>
                                "Personal Information" means any information that identifies, relates to, describes, or could reasonably be linked, directly or indirectly, to an identified or identifiable individual.
                            </p>

                            <div className="sub-heading">Client</div>
                            <p>
                                A "Client" means any individual, business, organization, government entity, or other legal entity that purchases, requests, or intends to purchase Robustik's Services.
                            </p>

                            <div className="sub-heading">Visitor</div>
                            <p>
                                A "Visitor" means any person who accesses or browses the Website without necessarily becoming a Client.
                            </p>

                            <div className="sub-heading">Processing</div>
                            <p>
                                "Processing" means any operation performed on Personal Information, whether by automated or manual means, including collection, recording, organization, storage, retrieval, consultation, use, disclosure, transfer, restriction, deletion, destruction, or any combination of these activities.
                            </p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">4.1. Information We Collect</div>
                        <div className="content" >
                            <p>
                                The categories of Personal Information we collect depend upon how you interact with Robustik, our Website, and our Services.
                            </p>
                            <p>
                                We collect only the information that is reasonably necessary to:
                            </p>
                            <ul>
                                <li>Provide our Services.</li>
                                <li>Respond to enquiries and consultation requests.</li>
                                <li>Prepare quotations and proposals.</li>
                                <li>Manage projects and client relationships.</li>
                                <li>Fulfil contractual obligations.</li>
                                <li>Comply with applicable laws</li>
                                <li>Protect our legitimate business interests.</li>
                            </ul>
                            <p>
                                We do not knowingly collect Personal Information that is unnecessary for these purposes.
                            </p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">4.2. Information You Voluntarily Provide</div>
                        <div className="content" >
                            <p>
                                You may voluntarily provide Personal Information when communicating with us, requesting Services, completing forms, or engaging with our business.
                            </p>

                            <div className="sub-heading">Identity Information</div>
                            <p>We may collect:</p>
                            <ul>
                                <li>Full Name.</li>
                                <li>Company Name.</li>
                                <li>Business Name.</li>
                                <li>Job Title.</li>
                                <li>Organization Name (where applicable).</li>
                            </ul>

                            <div className="sub-heading ">Contact Information</div>
                            <p>Including:</p>
                            <ul>
                                <li>Email Address.</li>
                                <li>Telephone Number.</li>
                                <li>WhatsApp Number.</li>
                                <li>Country.</li>
                                <li>State of Province (where applicable).</li>
                                <li>Preferred Communication Method.</li>
                            </ul>

                            <div className="sub-heading ">Business Information</div>
                            <p>Including:</p>
                            <ul>
                                <li>Company Website.</li>
                                <li>Industry.</li>
                                <li>Business Description.</li>
                                <li>Existing Digital Assets.</li>
                                <li>Branding Information.</li>
                            </ul>



                            <div className="sub-heading ">Project Information</div>
                            <p>Depending on the Services requested, we may collect:</p>
                            <ul>
                                <li>Project Requirements.</li>
                                <li>Functional Requirements.</li>
                                <li>Technical Specifications.</li>
                                <li>Design Preferences.</li>
                                <li>Budget Range.</li>
                                <li>Timeline Expectations.</li>
                                <li>Business Goals.</li>
                                <li>Target Audience.</li>
                                <li>Competitor References.</li>
                                <li>Project Documentation.</li>
                            </ul>
                            <div className="sub-heading ">Uploaded / Attached Files and Content</div>
                            <p>You may voluntarily submit files including:</p>
                            <ul>
                                <li>Documents.</li>
                                <li>Images.</li>
                                <li>Logos.</li>
                                <li>Videos.</li>
                                <li>Brand Guidelines.</li>
                                <li>Wireframes.</li>
                                <li>Design Files.</li>
                                <li>Source Files.</li>
                                <li>Spreadsheets.</li>
                                <li>Presentations.</li>
                                <li>Any other project-related materials.</li>
                            </ul>


                            <div className="sub-heading ">Communication Records</div>
                            <p>When communicating with us, we may retain records including:</p>
                            <ul>
                                <li>Email Correspondence.</li>
                                <li>WhatsApp Conversations.</li>
                                <li>Contact Form Submissions.</li>
                                <li>Meeting Notes.</li>
                                <li>Consultation Records.</li>
                                <li>Customer Support Requests.</li>
                                <li>Feedback.</li>
                                <li>Survey Responses.</li>
                                <li>Testimonials (where permission has been granted).</li>
                            </ul>

                            <p>
                                Providing Personal Information is voluntary; however, certain information may be required for us to prepare quotations, provide Services, execute agreements, deliver Projects, or fulfil our contractual obligations.
                            </p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">4.3. Information Collected Automatically</div>
                        <div className="content" >
                            <p>
                                When you visit our Website, certain information may be collected automatically through your browser, device, cookies, analytics platforms, and similar technologies.
                            </p>
                            <p>
                                Although this information may not directly identify you on its own, it may become Personal Information when combined with other information available to us.
                            </p>

                            <div className="sub-heading">Device Information</div>
                            <p>We may collect information such as:</p>
                            <ul>
                                <li>Device Type.</li>
                                <li>Device Model.</li>
                                <li>Operating System.</li>
                                <li>Browser Type.</li>
                                <li>Screen Resolution.</li>
                                <li>Preferred Language.</li>
                                <li>Time Zone.</li>
                            </ul>

                            <div className="sub-heading ">Network Information</div>
                            <p>Including:</p>
                            <ul>
                                <li>IP Address.</li>
                                <li>Internet Service Provider (ISP).</li>
                                <li>Approximate Geographics Location.</li>
                                <li>Network Identifiers.</li>
                            </ul>

                            <div className="sub-heading ">Website Usage Information</div>
                            <p>Including:</p>
                            <ul>
                                <li>Pages Visited.</li>
                                <li>Time Spent on Pages.</li>
                                <li>Navigation Paths.</li>
                                <li>Scroll Behavior.</li>
                                <li>Click Activity.</li>
                                <li>Referral Sources.</li>
                                <li>Entry Pages.</li>
                                <li>Exit Pages.</li>
                                <li>Search Queries.</li>
                                <li>Session Duration.</li>
                                <li>Website Performance Metrics.</li>
                            </ul>
                            <div className="sub-heading ">Technical Infromation</div>
                            <p>Including:</p>
                            <ul>
                                <li>Date and Time of Access.</li>
                                <li>Error Logs.</li>
                                <li>Diagnostic Information.</li>
                                <li>Crash Reports.</li>
                                <li>Security Event Logs.</li>
                                <li>Performance Monitoring Information.</li>
                            </ul>
                            <p>We use this information to improve Website performance, analyse visitor behaviour, maintain security, detect fraudulent or malicious activity, troubleshoot technical issues, optimise user experience, and enhance our Services.</p>

                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">4.4. Information Received from Third Parties</div>
                        <div className="content" >
                            <p>Where permitted by applicable law, we may receive information about you from third-party sources.</p>
                            <p>These sources may include:</p>
                            <ul>
                                <li>Marketing Partners.</li>
                                <li>Analytics Providers.</li>
                                <li>Advertising Platforms.</li>
                                <li>CRM Platforms.</li>
                                <li>Customer Support Platforms.</li>
                                <li>Social Media Platforms.</li>
                                <li>Business Directories.</li>
                                <li>Referral Partners.</li>
                                <li>Publicly Available Sources.</li>
                                <li>Other lawful third-party sources.</li>
                            </ul>
                            <p>Any Personal Information received from third parties will be processed in accordance with this Privacy Policy and applicable law.</p>
                            <p>Where reasonably practicable, we take steps to ensure that information received from third parties has been collected lawfully and may be used for the purposes for which it is provided.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">4.5. Sensitive Personal Information</div>
                        <div className="content" >
                            <p>Our Services are <strong>not intended</strong> to collect Sensitive Personal Information unless such information is reasonably necessary for providing requested Services or complying with applicable legal obligations.</p>

                            <p>Unless specifically requested by Robustik, we ask that you <strong>do not submit</strong> Sensitive Personal Information.</p>
                            <p>Sensitive Personal Information may include, without limitation:</p>
                            <ul>
                                <li>Government Identification Numbers.</li>
                                <li>Passport Information.</li>
                                <li>National Identity Documents.</li>
                                <li>Financial Account Credentials.</li>
                                <li>Credit or Debit Card PINs.</li>
                                <li>Medical Records.</li>
                                <li>Health Information.</li>
                                <li>Biometric Information.</li>
                                <li>Religious or Philosophical Beliefs.</li>
                                <li>Political Opinions.</li>
                                <li>Criminal Records.</li>
                                <li>Genetic Information.</li>
                                <li>Any other information classified as sensitive under applicable law.</li>

                            </ul>
                            <p>Where Sensitive Personal Information is required for a specific Project or legal purpose, it will be processed only where legally permitted and subject to appropriate administrative, technical, and organisational safeguards.</p>
                            <p>Robustik will not intentionally use Sensitive Personal Information for marketing purposes or disclose such information except where required to provide the requested Services, comply with legal obligations, or with the individual's explicit consent where required by law.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">5.1. Cookies and Similar Technologies</div>
                        <div className="content" >
                            <p>Robustik uses cookies and similar technologies to enhance Website functionality, improve user experience, analyse Website performance, support security, and measure the effectiveness of our marketing activities.</p>
                            <p>Cookies are small text files that are stored on your device when you visit our Website. These technologies help us recognize your browser, remember your preferences, improve Website performance, and better understand how visitors interact with our Services.</p>
                            <p>Depending on your browser settings, applicable law, and your consent preferences, we may use the following categories of cookies:</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">5.2. Essential Cookies</div>
                        <div className="content" >
                            <p>Essential Cookies are necessary for the operation and security of our Website and cannot generally be disabled through our Website.</p>

                            <p>These cookies may be used for purposes including:</p>
                            <ul>
                                <li>Website security.</li>
                                <li>Authentication.</li>
                                <li>Session management.</li>
                                <li>Form functionality.</li>
                                <li>Fraud prevention.</li>
                                <li>Load balancing.</li>
                                <li>System administration.</li>
                            </ul>
                            <p>Without these cookies, certain Website features may not function properly.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">5.3. Functional Cookies</div>
                        <div className="content" >
                            <p>Functional Cookies improve your browsing experience by remembering your preferences and settings.</p>
                            <p>These cookies may remember:</p>
                            <ul>
                                <li>Preferred language.</li>
                                <li>Region or country selection.</li>
                                <li>User interface preferences.</li>
                                <li>Accessibility settings.</li>
                                <li>Previously selected options.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">5.4. Analytics Cookies</div>
                        <div className="content" >
                            <p>Analytics technologies help us understand how visitors use our Website so that we can improve performance and user experience.</p>
                            <p>We may use analytics services including:</p>
                            <ul>
                                <li>Google Analytics.</li>
                                <li>Microsoft Clarity.</li>
                                <li>Other analytics platforms that may be implemented in the future.</li>
                            </ul>
                            <p>These technologies may collect information regarding:</p>
                            <ul>
                                <li>Pages visited.</li>
                                <li>Navigation paths.</li>
                                <li>Session duration.</li>
                                <li>Device information.</li>
                                <li>Browser information.</li>
                                <li>Website interactions.</li>
                                <li>Anonymous performance metrics.</li>
                            </ul>
                            <p>Where reasonably possible, analytics information is collected in aggregated or pseudonymised form.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">5.5. Marketing Cookies</div>
                        <div className="content" >
                            <p>Subject to applicable law and your consent where required, we may use marketing technologies including:</p>
                            <ul>
                                <li>Meta Pixel.</li>
                                <li>LinkedIn Insight Tag.</li>
                                <li>Google Ads Conversion Tracking.</li>
                                <li>Other advertising technologies implemented in the future.</li>
                            </ul>
                            <p>These technologies help us:</p>
                            <ul>
                                <li>Measure advertising effectiveness.</li>
                                <li>Understand campaign performance.</li>
                                <li>Improve marketing activities.</li>
                                <li>Deliver more relevant advertisements.</li>
                            </ul>
                            <p>Where reasonably possible, analytics information is collected in aggregated or pseudonymised form.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">5.6. Google Tag Manager</div>
                        <div className="content" >
                            <p>We may use Google Tag Manager to deploy and manage Website scripts and tracking technologies.</p>
                            <p>Google Tag Manager does not generally collect Personal Information itself; however, it facilitates the operation of tags that may collect information in accordance with their respective privacy policies.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">5.7. Managing Cookie Preferences</div>
                        <div className="content" >
                            <p>Where required by applicable law, our Website may display a Cookie Consent Banner that allows you to accept, reject, or customise non-essential cookies.</p>
                            <p>You may also control cookies through:</p>
                            <ul>
                                <li>Your browser settings.</li>
                                <li>Device privacy settings.</li>
                                <li>Third-party opt-out tools where available.</li>
                            </ul>
                            <p>Please note that disabling certain cookies may affect the functionality, security, or performance of portions of our Website.</p>

                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">6. Artificial Intelligence (AI)</div>
                        <div className="content" >
                            <p>Robustik may use Artificial Intelligence ("AI") technologies to improve operational efficiency, enhance productivity, and assist in delivering high-quality Services.</p>
                            <p>AI tools may be used for activities including, but not limited to:</p>
                            <ul>
                                <li>Content drafting.</li>
                                <li>Copywriting assistance.</li>
                                <li>Brainstorming.</li>
                                <li>Software development assistance.</li>
                                <li>Code generation.</li>
                                <li>UI/UX ideation.</li>
                                <li>Design assistance.</li>
                                <li>Image generation.</li>
                                <li>Document preparation.</li>
                                <li>Translation.</li>
                                <li>Research assistance.</li>
                                <li>Workflow automation.</li>
                                <li>Internal productivity improvements.</li>
                            </ul>
                            <p>AI-generated outputs are intended solely as assistive tools.</p>
                            <p>Where reasonably practicable, AI-generated work is reviewed, evaluated, and refined by a qualified human before being delivered to clients.</p>
                            <p>Clients remain responsible for reviewing and approving all final deliverables before publication, implementation, or commercial use.</p>
                            <p><strong>Robustik does not currently make solely automated decisions that produce legal or similarly significant effects on individuals without meaningful human involvement.</strong></p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">7.1. How We Use Your Information</div>
                        <div className="content" >
                            <p>We process Personal Information only for legitimate business purposes and only where reasonably necessary to operate our business, provide our Services, fulfil contractual obligations, comply with applicable laws, or protect our legitimate interests.</p>
                            <p>We may use your Personal Information for the following purposes:</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">7.2. Service Delivery</div>
                        <div className="content" >
                            <p>Including:</p>
                            <ul>
                                <li>Responding to enquiries.</li>
                                <li>Preparing quotations and proposals.</li>
                                <li>Providing consultations.</li>
                                <li>Delivering requested Services.</li>
                                <li>Managing Projects.</li>
                                <li>Providing customer support.</li>
                                <li>Communicating project updates.</li>
                                <li>Delivering agreed deliverables.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">7.3. Business Operations</div>
                        <div className="content" >
                            <p>Including:</p>
                            <ul>
                                <li>Managing client relationships.</li>
                                <li>Maintaining internal business records.</li>
                                <li>Preparing contracts.</li>
                                <li>Processing invoices.</li>
                                <li>Maintaining quality assurance.</li>
                                <li>Improving operational efficiency.</li>
                                <li>Internal reporting.</li>
                                <li>Business administration.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">7.4. Website Improvement</div>
                        <div className="content" >
                            <p>Including:</p>
                            <ul>
                                <li>Monitoring Website performance.</li>
                                <li>Analyzing Website usage.</li>
                                <li>Improving user experience.</li>
                                <li>Developing new features.</li>
                                <li>Correcting technical issues.</li>
                                <li>Enhancing Website security.</li>
                                <li>Measuring Website effectiveness.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">7.5. Marketing and Communications</div>
                        <div className="content" >
                            <p>Where permitted by applicable law, we may use your Personal Information to:</p>
                            <ul>
                                <li>Respond to marketing enquiries.</li>
                                <li>Send service-related communications.</li>
                                <li>Provide educational content.</li>
                                <li>Share newsletters.</li>
                                <li>Announce new Services.</li>
                                <li>Notify you about promotions.</li>
                                <li>Conduct customer satisfaction surveys.</li>
                            </ul>
                            <p>You may unsubscribe from non-essential marketing communications at any time using the unsubscribe instructions included in our communications or by contacting us directly.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">7.6. Security and Fraud Prevention</div>
                        <div className="content" >
                            <p>We may process information to:</p>
                            <ul>
                                <li>Protect our Website.</li>
                                <li>Detect fraud.</li>
                                <li>Prevent abuse.</li>
                                <li>Investigate suspicious activity.</li>
                                <li>Respond to security incidents.</li>
                                <li>Protect our intellectual property.</li>
                                <li>Enforce our agreements.</li>
                                <li>Maintain system integrity.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">7.7. Legal and Regulatory Compliance</div>
                        <div className="content" >
                            <p>We may process Personal Information where reasonably necessary to:</p>
                            <ul>
                                <li>Comply with applicable laws.</li>
                                <li>Respond to lawful requests.</li>
                                <li>Meet regulatory obligations.</li>
                                <li>Resolve disputes.</li>
                                <li>Protect our legal rights.</li>
                                <li>Enforce contracts.</li>
                                <li>Defend legal claims.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">8. Legal Basis for Processing</div>
                        <div className="content" >
                            <p>Where applicable under relevant privacy laws, Robustik processes Personal Information based upon one or more lawful grounds, including:</p>
                            <ul>
                                <li>Your consent.</li>
                                <li>Performance of a contract or pre-contractual measures requested by you.</li>
                                <li>Compliance with legal obligations.</li>
                                <li>Protection of our legitimate business interests.</li>
                                <li>Protection of vital interests where applicable.</li>
                                <li>Any other lawful basis permitted under applicable law.</li>
                            </ul>
                            <p>Where processing is based upon your consent, you may withdraw that consent at any time. Withdrawal of consent will not affect the lawfulness of processing carried out before such withdrawal.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">9.1. Service Providers</div>
                        <div className="content" >
                            <p>We may share Personal Information with carefully selected third-party service providers that perform services on our behalf, including but not limited to:</p>
                            <ul>
                                <li>Website Hosting Providers.</li>
                                <li>Cloud Infrastructure Providers.</li>
                                <li>Email Service Providers.</li>
                                <li>Customer Support Platforms.</li>
                                <li>CRM Systems.</li>
                                <li>Project Management Platforms.</li>
                                <li>Analytics Providers.</li>
                                <li>Communication Platforms.</li>
                                <li>Security Monitoring Services.</li>
                                <li>Backup and Disaster Recovery Providers.</li>
                            </ul>
                            <p>These providers are contractually or legally required to process Personal Information only for the purposes for which it is provided and to implement appropriate security measures.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">9.2. Payment Processing Providers</div>
                        <div className="content" >
                            <p>Payments for our Services may be processed through trusted third-party payment providers.</p>
                            <p>Depending on our business structure and payment arrangements at the time of payment, payment processing may be handled by:</p>
                            <ul>
                                <li>Stripe.</li>
                                <li>Airwallex.</li>
                                <li>Other authorised payment processors.</li>
                                <li>An authorized billing partner during our business setup phase, where applicable.</li>
                            </ul>
                            <p>Clients will always receive clear payment instructions before any payment is requested.</p>
                            <p>Robustik does <strong>not</strong> store full payment card numbers, CVV codes, or complete payment credentials on its own servers.</p>
                            <p>Payment providers process payment information in accordance with their own privacy policies, security standards, and regulatory obligations.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">9.3. Professional Advisors</div>
                        <div className="content" >
                            <p>Where reasonably necessary, we may disclose Personal Information to our professional advisors, including:</p>
                            <ul>
                                <li>Lawyers.</li>
                                <li>Accountants.</li>
                                <li>Auditors.</li>
                                <li>Compliance Consultants.</li>
                                <li>Insurance Providers.</li>
                                <li>Tax Advisors.</li>
                            </ul>
                            <p>Such disclosures shall be limited to information reasonably necessary for legal, financial, regulatory, insurance, or business purposes.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">9.4. Legal Authorities</div>
                        <div className="content" >
                            <p>We may disclose Personal Information where we reasonably believe disclosure is necessary to:</p>
                            <ul>
                                <li>Comply with applicable laws.</li>
                                <li>Respond to lawful requests from government authorities.</li>
                                <li>Comply with court orders or legal processes.</li>
                                <li>Protect our legal rights.</li>
                                <li>Investigate fraud or unlawful activities.</li>
                                <li>Protect public safety.</li>
                                <li>Enforce our contracts and policies.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">9.5. Business Transfers</div>
                        <div className="content" >
                            <p>If Robustik undergoes or is involved in:</p>
                            <ul>
                                <li>Merger.</li>
                                <li>Acquisition.</li>
                                <li>Investment.</li>
                                <li>Corporate restructuring.</li>
                                <li>Asset sale.</li>
                                <li>Business succession.</li>
                            </ul>
                            <p>Personal Information may be transferred as part of that transaction, subject to applicable legal requirements and appropriate confidentiality protections.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">10. International Data Transfers</div>
                        <div className="content" >
                            <p>Because Robustik serves clients globally, Personal Information may be transferred to, processed in, or stored in countries other than your country of residence.</p>
                            <p>These jurisdictions may have data protection laws that differ from those of your own country.</p>
                            <p>Where reasonably required, Robustik implements commercially reasonable safeguards designed to protect Personal Information during international transfers, including:</p>
                            <ul>
                                <li>Contractual confidentiality obligations.</li>
                                <li>Secure cloud infrastructure.</li>
                                <li>Trusted service providers.</li>
                                <li>Industry-standard security practices.</li>
                                <li>Access controls and organizational safeguards.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">11. Data Retention</div>
                        <div className="content" >
                            <p>Robustik retains Personal Information only for as long as reasonably necessary to:</p>
                            <ul>
                                <li>Establish, exercise, or defend legal claims.</li>
                                <li>Prevent fraud, abuse, or unauthorized activities.</li>
                                <li>Comply with legal, regulatory, taxation, accounting, or reporting obligations.</li>
                                <li>Resolve disputes.</li>
                                <li>Enforce contractual agreements.</li>
                                <li>Protect the security and integrity of our systems.</li>
                            </ul>
                            <p>Retention periods vary depending on the nature of the information, the Services provided, and applicable legal obligations.</p>
                            <p><strong className="text-white">Additional Data Retention</strong></p>
                            <p>In certain circumstances, Robustik may retain Personal Information for longer periods where reasonably necessary to:</p>
                            <ul>
                                <li>Establish, exercise, or defend legal claims.</li>
                                <li>Prevent fraud, abuse, or unauthorized activities.</li>
                                <li>Comply with legal, regulatory, taxation, accounting, or reporting obligations.</li>
                                <li>Resolve disputes.</li>
                                <li>Enforce contractual agreements.</li>
                                <li>Protect the security and integrity of our systems.</li>
                            </ul>
                            <p>Where Personal Information is no longer required, it will be securely deleted, anonymised, or otherwise disposed of using commercially reasonable methods.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">12. Data Security</div>
                        <div className="content" >
                            <p>Robustik implements reasonable administrative, technical, organisational, and physical safeguards designed to protect Personal Information against unauthorised access, disclosure, alteration, misuse, loss, or destruction.</p>
                            <p>Security measures may include:</p>
                            <ul>
                                <li>Secure hosting environments.</li>
                                <li>Encryption where appropriate.</li>
                                <li>Role-based access controls.</li>
                                <li>Authentication mechanisms.</li>
                                <li>Firewall protection.</li>
                                <li>Security monitoring.</li>
                                <li>Routine software updates.</li>
                                <li>Backup procedures.</li>
                                <li>Employee confidentiality obligations.</li>
                                <li>Industry-standard security practices.</li>
                            </ul>
                            <p>While we continuously strive to protect Personal Information, no method of electronic transmission or storage is completely secure.</p>
                            <p>Accordingly, Robustik cannot guarantee absolute security.</p>
                            <p>Users are also responsible for maintaining the confidentiality of their passwords, devices, authentication credentials, and account access.</p>
                            <p><strong className="text-white">Data Breach Notification</strong></p>
                            <p>In the event of a confirmed Personal Data breach, Robustik will take commercially reasonable steps to investigate, contain, mitigate, and provide any notifications required under applicable law.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">13. Your Privacy Rights</div>
                        <div className="content" >
                            <p>Subject to applicable laws, you may have certain rights regarding your Personal Information.</p>
                            <p>Depending on your jurisdiction, these rights may include the ability to:</p>
                            <ul>
                                <li>Request access to your Personal Information.</li>
                                <li>Request correction of inaccurate information.</li>
                                <li>Request deletion of Personal Information where legally permitted.</li>
                                <li>Request restriction of processing.</li>
                                <li>Object to certain processing activities.</li>
                                <li>Withdraw consent where processing is based on consent.</li>
                                <li>Request a portable copy of your Personal Information where applicable.</li>
                                <li>Submit complaints to the appropriate regulatory authority where permitted by law.</li>
                            </ul>
                            <p>To protect your information, Robustik may request reasonable identity verification before processing privacy-related requests.</p>
                            <p>Certain legal, contractual, or regulatory obligations may limit our ability to fulfil particular requests.</p>
                            <p><strong className="text-white">Response Time</strong></p>
                            <p>Robustik will use commercially reasonable efforts to respond to verified privacy requests within <strong>thirty (30) calendar days</strong>, unless a longer period is permitted or required under applicable law.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">14. Children's Privacy</div>
                        <div className="content" >
                            <p>Our Website and Services are intended for businesses, professionals, and individuals who are legally capable of entering into binding agreements.</p>
                            <p>Our Services are <strong>not directed toward children under the age of 13</strong>, and we do not knowingly collect Personal Information from children.</p>
                            <p>Where applicable law establishes a higher minimum age requirement, that higher age requirement shall apply.</p>
                            <p>If we become aware that Personal Information has been collected from a child without appropriate authorisation, we will take reasonable steps to delete such information.</p>
                            <p>Parents or legal guardians who believe that a child has submitted Personal Information may contact us using the details provided below.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">15. Third-Party Websites and Services</div>
                        <div className="content" >
                            <p>Our Website may contain links to third-party websites, platforms, applications, or services that are not owned or controlled by Robustik.</p>
                            <p>We are not responsible for the privacy practices, security measures, availability, content, or policies of those third parties.</p>
                            <p>Your use of third-party services is subject to their own terms, conditions, and privacy policies.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">16. Changes to this Privacy Policy</div>
                        <div className="content" >
                            <p>Robustik may revise this Privacy Policy from time to time to reflect:</p>
                            <ul>
                                <li>Changes in applicable laws.</li>
                                <li>Regulatory requirements.</li>
                                <li>Business operations.</li>
                                <li>New Services or technologies.</li>
                                <li>Security improvements.</li>
                                <li>Operational requirements.</li>
                            </ul>
                            <p>Updated versions become effective upon publication unless otherwise stated.</p>
                            <p>The "Last Updated" date shown in this document will indicate the most recent revision.</p>
                            <p>Where legally required, additional notice may be provided regarding material changes.</p>
                            <p>Continued use of our Website or Services after publication constitutes acceptance of the revised Privacy Policy.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">17. Contact Us</div>
                        <div className="content" >
                            <p>If you have any questions regarding this Privacy Policy or wish to exercise your privacy rights, you may contact us at:</p>
                            <p><strong>Robustik (Robustik LLC upon registration)</strong></p>
                            <p>Email: <strong>contact@robustik.com</strong></p>
                            <p>Registered Business Address:</p>
                            <p>To be updated upon company registration.</p>
                            <p>Additional contact methods may be published on our official Website from time to time.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">18. Governing Law</div>
                        <div className="content" >
                            <p>This Privacy Policy shall be governed by and interpreted in accordance with the laws of the <strong>State of Wyoming, United States</strong>, without regard to its conflict of law principles, except where mandatory consumer protection laws of another jurisdiction apply.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">19. Severability</div>
                        <div className="content" >
                            <p>If any provision of this Privacy Policy is determined to be unlawful, invalid, or unenforceable by a court or competent authority, the remaining provisions shall continue in full force and effect to the maximum extent permitted by applicable law.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">20. Entire Policy</div>
                        <div className="content" >
                            <p>This Privacy Policy constitutes the complete Privacy Policy of Robustik regarding the collection, use, processing, storage, disclosure, retention, and protection of Personal Information.</p>
                            <p>Nothing in this Privacy Policy limits any additional rights or obligations contained in separate agreements, contracts, Statements of Work (SOW), Master Service Agreements (MSA), or other legally binding documents executed between Robustik and its clients.</p>
                        </div>
                    </div>


                </div>
            </section>

        </>
    )
}
